import { render } from "./Themes.vue?vue&type=template&id=88b12750&scoped=true"
import script from "./Themes.vue?vue&type=script&lang=js"
export * from "./Themes.vue?vue&type=script&lang=js"

import "./Themes.vue?vue&type=style&index=0&id=88b12750&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88b12750"]])

export default __exports__